import { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../Tabs/Settings/CustomInput";
import Pencil from "../../../assets/images/pencil.svg";
import {
  getSignedUrl,
  profileInfo
} from "../../../Store/api/professor/settings";
import storage from "../../../services/storage";
import { ImageUpload } from "../../../shared/ImageUplader";
import axios from "axios";
import { updateUser } from "../../../Store/auth/authReducer";
import ArrowRight from "../../../assets/images/Arrow-right-dark.svg";

export default function PersonalInformation() {
  const dispatch = useDispatch();
  const [err, setError] = useState(null);
  const [img, setImage] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [imgLoading, setImgLoading] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [userInfo, setUserInfo] = useState(user);

  useEffect(() => {
    setUserInfo(user);
  }, [user]);

  useEffect(() => {
    setError(null);
  }, [userInfo]);

  const uploadImage = async (file, signedUrl, imgUrl) => {
    try {
      await axios.put(signedUrl, file, {
        headers: {
          "Content-Type": file.type
        }
      });
      setImage(imgUrl);
      // const user = storage.get("user");
      // storage.store("user", { ...user, image: imgUrl });
      setImgLoading(false);
    } catch (error) {
      setImgLoading(false);
      if (error?.response?.data && error?.response?.data?.message) {
        setError(error.response.data.message);
      } else {
        setError("Something went wrong while uploading image.");
      }
    }
  };

  const changeHandler = (e) => {
    setError(null);
    setUserInfo((old) => {
      return { ...old, [e.target.name]: e.target.value };
    });
  };

  const fetchSignedUrl = (file) => {
    setImgLoading(true);
    dispatch(
      getSignedUrl({
        body: { fileType: file.type },
        onSuccess: (res) => {
          uploadImage(file, res.url, res.key);
        },
        onError: (error) => {
          if (error.response.data && error.response.data.message) {
            setError(error.response.data.message);
          } else {
            setError("Something went wrong while creating signed url.");
          }
        }
      })
    );
  };

  return (
    <div className="box_border_settings">
      <div className="settings_header">
        <h2>personal information</h2>
        <div className="settings_header">
          <p
            className="mb-0 editt cursor"
            onClick={() => {
              setIsEditing((prev) => !prev);
              err && isEditing && setError(null);
            }}>
            {isEditing ? "editing" : "edit"}
          </p>
        </div>
      </div>
      {isLoading ? (
        "loading..."
      ) : (
        <Fragment>
          {isEditing ? (
            <Fragment>
              <div
                className="setting_rows justify-content-between"
                style={{ alignItems: "start" }}>
                <p className="key">Name</p>
                <div style={{ width: "67%" }}>
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    value={userInfo.firstName}
                    className="form-control"
                    style={{ display: "block", marginBottom: "4px" }}
                    onChange={changeHandler}
                  />
                  <input
                    type="text"
                    placeholder="Last name"
                    name="lastName"
                    value={userInfo.lastName}
                    className="form-control"
                    style={{ display: "block", marginBottom: "4px" }}
                    onChange={changeHandler}
                  />
                </div>
                <p
                  className="edit_buttton cursor"
                  onClick={() => {
                    // setIsPasswordEditing(false);
                  }}>
                  <img className="white-to-black" src={Pencil} alt="" />
                </p>
              </div>
              <CustomInput
                isEditing={isEditing}
                type={"tel"}
                title={"Pronounces"}
                name={"pronouns"}
                value={userInfo.pronouns || ""}
                onChange={changeHandler}
              />
              <CustomInput
                isEditing={isEditing}
                type={"tel"}
                title={"Location"}
                name={"location"}
                value={userInfo.location}
                onChange={changeHandler}
              />
              <CustomInput
                isEditing={isEditing}
                type={"tel"}
                title={"Location timezone"}
                name={"locationTimeZone"}
                value={userInfo.locationTimeZone}
                onChange={changeHandler}
              />

              <div className="setting_rows">
                <p className="key">Profile Picture</p>
                <p className="value">
                  <ImageUpload
                    imageUrl={img || userInfo?.image || ""}
                    fetchSignedUrl={fetchSignedUrl}
                    loading={imgLoading}
                  />
                </p>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div className="setting_rows">
                <p className="key">Name</p>
                <p className="value">
                  <input
                    type="text"
                    value={userInfo.firstName + " " + userInfo.lastName}
                  />
                  <img src="" alt="" />
                </p>
              </div>
              <div className="setting_rows">
                <p className="key">Pronouns</p>
                <p className="value">
                  <input type="text" value={userInfo.pronouns || "--"} />
                </p>
              </div>
              <div className="setting_rows">
                <p className="key">Location</p>
                <p className="value">
                  <input type="text" value={userInfo.location || "--"} />
                </p>
              </div>
              <div className="setting_rows">
                <p className="key">Location Timezone</p>
                <p className="value">
                  <input
                    type="text"
                    value={userInfo.locationTimeZone || "--"}
                  />
                </p>
              </div>
              <div className="setting_rows">
                <p className="key">Profile Picture</p>
                <p className="value">
                  <div
                    style={{
                      width: "35px",
                      height: "35px",
                      lineHeight: "35px",
                      textAlign: "center",
                      borderRadius: "50%",
                      color: "white",
                      background: "#888",
                      fontSize: "16px",
                      fontWeight: "400"
                    }}>
                    {userInfo?.image ? (
                      <img
                        src={userInfo.image}
                        alt="profile_photo"
                        style={{
                          width: "35px",
                          height: "35px",
                          objectFit: "cover"
                        }}
                      />
                    ) : (
                      `${userInfo.firstName[0]}${userInfo.lastName[0]}`
                    )}
                  </div>
                </p>
              </div>
            </Fragment>
          )}
        </Fragment>
      )}
      {isEditing && (
        <div className="setting_rows" style={{ marginBottom: "0px" }}>
          <p className="key"></p>
          <p className="value">
            <p className="main_part" style={{ color: "red" }}>
              {err && `${err}`}
            </p>
            <p
              className="edit_buttton cursor"
              onClick={() => {
                let er = "";
                // if (!userInfo.location) {
                //   er = 'Location is required.';
                // }
                // if (!userInfo.locationTimeZone) {
                //   er = 'Location timezone is required.';
                // }
                if (!userInfo.firstName) {
                  er = "First name is required.";
                }
                if (!userInfo.lastName) {
                  er = "Last name is required.";
                }
                if (er) {
                  setError(er);
                  return;
                }
                const apiBody = {
                  location: userInfo.location,
                  locationTimeZone: userInfo.locationTimeZone,
                  firstName: userInfo.firstName,
                  lastName: userInfo.lastName,
                  pronouns: userInfo.pronouns,
                  ...(img && { image: img })
                };
                setError(null);
                setIsLoading(true);
                dispatch(
                  profileInfo({
                    body: apiBody,
                    onSuccess: (res) => {
                      setIsLoading(false);
                      storage.store("user", res.data.data);
                      dispatch(updateUser(res.data.data));
                      setIsEditing(false);
                    },
                    onError: (error) => {
                      setIsLoading(false);
                      if (error.response.data && error.response.data.message) {
                        setError(error.response.data.message);
                      } else {
                        setError("Something went wrong!");
                      }
                    }
                  })
                );
              }}>
              Save <img src={ArrowRight} alt="save" className="ms-1" />
            </p>
          </p>
        </div>
      )}
    </div>
  );
}
